import {
  Box,
  Button,
  Heading,
  Image,
  Flex,
  Container,
  Stack,
} from '@chakra-ui/react';
import { NextSeo } from 'next-seo';

import { HoveringBox } from '~/components/ui/motion/Box';
import { useFilters } from '~/hooks/useFilters';
import { NestedHome } from '@habity/types';
import { RelatedHomes } from '../../homes/profile/components/related/RelatedHomes';
import { useAgency } from '~/hooks/useAgency';
import { useUser } from '~/hooks/useUser';

const HomeNotFound = ({
  home,
  relatedHomes,
  relatedHomesLoading,
  hasMore,
  loadMore,
}: {
  home?: NestedHome;
  relatedHomes: NestedHome[];
  relatedHomesLoading: boolean;
  hasMore: boolean;
  loadMore: () => void;
}) => {
  const { performSearch } = useFilters();
  const { getIllustrationsRoute } = useAgency();
  const { user } = useUser();
  const { status } = home || {};
  const { name } = status || {};

  // Use home parameter to display custom message if needed
  const message = !home
    ? 'Bostaden kan inte hittas'
    : name === 'sold'
    ? 'Bostaden verkar ha sålts 🎉'
    : 'Bostaden verkar ha sålts eller tagits bort 🤷‍♂️';

  return (
    <>
      <Flex minHeight="70vh" direction="column" justifyContent="center">
        <NextSeo title="Bostaden hittades inte" />
        <HoveringBox>
          <Image
            src={getIllustrationsRoute('no-results.svg')}
            alt="Error 404 not found Illustration"
          />
        </HoveringBox>
        {/* <Text textAlign="center" fontSize="xs" color="gray">
        <ChakraLink
          href="https://stories.freepik.com/web"
          isExternal
          rel="noopener noreferrer"
        >
          Illustration by Freepik Stories
        </ChakraLink>
      </Text> */}

        <Box pb={30}>
          <Heading textAlign="center" size="md">
            {message}
          </Heading>

          <Box textAlign="center" marginTop={4}>
            <Button
              onClick={() =>
                performSearch({
                  filters: null,
                  includeExistingFilters: true,
                })
              }
              size="lg"
            >
              Gå tillbaka
            </Button>
          </Box>
        </Box>
      </Flex>
      <Container px="0" maxW="7xl" pb="48">
        <Box width="100%" py={{ mobile: '0', tablet: '4', desktop: '6' }}>
          <Stack px={{ mobile: '4', tablet: '12', desktop: '16' }} py="6">
            <RelatedHomes
              relatedHomes={relatedHomes}
              relatedHomesLoading={relatedHomesLoading}
              hasMore={hasMore}
              loadMore={loadMore}
              user={user}
            />
          </Stack>
        </Box>
      </Container>
    </>
  );
};

export default HomeNotFound;
